var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "margin-bottom": "50px" } },
    [
      _c("bj-form", {
        attrs: {
          "col-span": _vm.colSpan,
          "label-position": "top",
          "label-width": "140px",
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("billingPage.ImportCSV") } },
                          [
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  accept: ".csv,.xls,.xlsx",
                                  action: "",
                                  limit: 1,
                                  "auto-upload": false,
                                  "on-change": _vm.handleChange,
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { type: "primary" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("billingPage.ClickImport"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("billingPage.Carrier") } },
                          [
                            _c("BjSelectLov", {
                              attrs: { "option-list": _vm.companyList },
                              model: {
                                value: _vm.params.companyName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "companyName", $$v)
                                },
                                expression: "params.companyName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      {
                        staticStyle: { margin: "28px 0px 0px 50px" },
                        attrs: { span: 10 },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled:
                                !_vm.params.companyName || !_vm.params.name,
                            },
                            on: { click: _vm._compareShippingCharge },
                          },
                          [_vm._v(_vm._s(_vm.$t("billingPage.COMPARE")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("BjDivider", { attrs: { "right-fixed": "" } }, [
        _vm._v(_vm._s(_vm.$t("billingPage.UnMatched"))),
      ]),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.dataInfo.unmatchedItems, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: _vm.$t("billingPage.index"),
              align: "center",
              width: "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "consignmentNum",
              label: _vm.$t("billingPage.consignmentNum"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "invoicePrice",
              label: _vm.$t("billingPage.invoicePrice"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v("$" + _vm._s(scope.row.invoicePrice))]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(_vm._s(_vm.$t("billingPage.MatchedItems")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v(_vm._s(_vm.$t("submitText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.dataInfo.matchedItems, border: "" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              width: "50",
              selectable: _vm.checkSelectable,
            },
          }),
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: _vm.$t("billingPage.index"),
              align: "center",
              width: "50",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "orderId",
              label: _vm.$t("billingPage.orderID"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "consignmentNum",
              label: _vm.$t("billingPage.consignmentNum"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "invoicePrice",
              label: _vm.$t("billingPage.invoicePrice"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v("$" + _vm._s(scope.row.invoicePrice))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ratedPrice",
              label: _vm.$t("billingPage.ratedPrice"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v("$" + _vm._s(scope.row.ratedPrice))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "invoiceTotalPrice",
              label: _vm.$t("billingPage.Carrierinvoicetotalprice"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v("$" + _vm._s(scope.row.invoiceTotalPrice))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "difference",
              label: _vm.$t("billingPage.difference"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v("$" + _vm._s(scope.row.difference))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "totalSurchargedPrice",
              label: _vm.$t("billingPage.TotalsurchargedPrice"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v("$" + _vm._s(scope.row.totalSurchargedPrice))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "needChargePrice",
              label: _vm.$t("billingPage.needChargePrice"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v("$" + _vm._s(scope.row.needChargePrice))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ifNeedCharge",
              label: _vm.$t("billingPage.ifNeedCharge"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.ifNeedCharge ? "success" : "info",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                _vm.STATUS_YES_TRUE.bjGet(
                                  scope.row.ifNeedCharge
                                )
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "clientCode",
              label: _vm.$t("billingPage.clientCode"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "marginRate",
              label: _vm.$t("billingPage.MarginRate"),
              align: "center",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }